import React from "react";
import { LOGO_URL } from "@/lib/api";

export function Brand({ size = 44, showText = true, sub = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="DA LE TANG HuoGuo"
        style={{ width: size, height: size }}
        className="object-contain"
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-display font-extrabold tracking-tight text-neutral-900 text-lg">
            DA LE TANG
          </div>
          {sub && <div className="text-[10px] font-semibold tracking-[0.35em] text-crimson uppercase">HuoGuo</div>}
        </div>
      )}
    </div>
  );
}
